import styled from 'styled-components';

export const Wrapper = styled.div`
  background: #f44336;
  border-radius: 3px;
  padding: 0.5rem 0.5rem;
`;
